// extracted by mini-css-extract-plugin
export default {"imageFallback":"ConfigurationImage__imageFallback___UdSJU"};